import type { isMultilingualProperty, MultilingualProperties } from "@skilitics/nautilus-core-designer-data";

export const toMultilingualCreate =
  (primaryLanguageCode: string) =>
  (value: string): MultilingualProperties => ({
    __ml: {
      [primaryLanguageCode]: value,
    },
  });

export type ToMultilingual = ReturnType<typeof toMultilingualCreate>;

export const fromMultilingualCreate = (primaryLanguageCode: string) => (value: MultilingualProperties) =>
  value.__ml[primaryLanguageCode];

export type FromMultilingual = ReturnType<typeof fromMultilingualCreate>;

export type IsMultilingual = typeof isMultilingualProperty;
